import React, { useEffect } from 'react';
import { Error } from 'src/components/form/Select';
import { ActionMeta, Props } from 'react-select';
import * as S from './ScenarioSelect.styles';
import { useAssessmentsScenarioNamesQuery } from 'src/graphql/_generated';

interface Option {
  label: string;
  value: string;
}

interface ScenarioSelectProps extends Omit<Props, 'value'> {
  value: string;
  onChange: (value: { label: string; value: string }, meta: ActionMeta<{ label: string; value: string }>) => void;
  error?: boolean;
  helperText?: string;
  placeholder?: string;
}

export const ScenarioSelect: React.FC<ScenarioSelectProps> = ({
  value,
  onChange,
  error,
  helperText,
  placeholder = 'Select Scenario',
}) => {
  const [options, setOptions] = React.useState<
    {
      label: string;
      options: Option[];
    }[]
  >([]);

  const { data: { assessments = [] } = {} } = useAssessmentsScenarioNamesQuery();

  useEffect(() => {
    const mapped = assessments.map((el) => {
      return {
        label: el.name,
        options: el.scenarios.map((s) => ({
          label: s.name!,
          value: s.id,
        })),
      };
    });
    setOptions(mapped);
  }, [assessments]);

  return (
    <>
      <S.StyledSelect
        value={options.reduce((acc: Option[], el) => acc.concat(el.options), []).find((el) => el.value === value)}
        placeholder={placeholder}
        options={options}
        onChange={onChange}
      />
      {error && helperText && <Error>{helperText}</Error>}
    </>
  );
};
